import axios from "axios";

import { initCommonSettings } from "@krea/customer-features/settings";

const settings = initCommonSettings({
  unauthorizedPaths: ["/login", "/register"],
});

// Set global axios config
axios.defaults.baseURL = settings.backendBaseUrl;

// TODO: Set up separate customerAxios that does cookie-auth
axios.defaults.withCredentials = false;
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

// eslint-disable-next-line import/no-default-export
export default settings;
